import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';
import { Upload } from 'lucide-react';

import { usePeopleAccessPaths } from '../../hooks';

/**
 * Inline prompt of the single-member invite flow (step 1, under the email field): taking it
 * leaves the stepper for the bulk import wizard; nothing entered carries over. Hosted by the
 * invite builder (CT-5610).
 */
function UploadInsteadPrompt() {
  const { t } = useTranslation('people-access');
  const navigate = useNavigate();
  const { importPath } = usePeopleAccessPaths();
  const handleClick = useCallback(() => navigate(importPath), [navigate, importPath]);

  return (
    <p className="flex flex-wrap items-center gap-x-1 text-sm text-content-secondary">
      <span>{t('import.uploadInstead.prompt')}</span>
      <Button variant="ghost" size="sm" leftIcon={Upload} onClick={handleClick}>
        {t('import.uploadInstead.action')}
      </Button>
    </p>
  );
}

export default UploadInsteadPrompt;
